/**
 * Klucz porównawczy dla nazw i oznaczeń — musi odpowiadać `DuplicateGuard.normalize`
 * po stronie serwera (przycięte skraje, ciągi białych znaków zwinięte do jednej spacji,
 * małe litery). Rozjazd oznaczałby, że front puszcza dalej coś, co serwer i tak odrzuci.
 */
export function normKey(raw: string | null | undefined): string {
  return (raw ?? '').trim().replace(/\s+/g, ' ').toLowerCase();
}

/** Czy `value` koliduje z którąkolwiek z pozycji `existing` (po znormalizowanym kluczu). */
export function collidesWith(value: string | null | undefined, existing: (string | null | undefined)[]): boolean {
  const key = normKey(value);
  if (!key) return false;
  return existing.some(e => normKey(e) === key);
}

/**
 * Indeksy pozycji, które powtarzają wcześniejszą wartość z tej samej listy. Pierwsze
 * wystąpienie zostaje czyste — podświetlamy dopiero powtórkę, bo to ona jest do poprawienia.
 */
export function repeatedIndexes(values: (string | null | undefined)[]): Set<number> {
  const seen = new Set<string>();
  const out = new Set<number>();
  values.forEach((v, i) => {
    const key = normKey(v);
    if (!key) return;
    if (seen.has(key)) out.add(i); else seen.add(key);
  });
  return out;
}

/**
 * Pierwsze wolne oznaczenie w serii `prefix-NN` (H-01, H-02, …), pomijając zajęte.
 * Licznik z długości listy dawał duplikat: skasowanie wiersza ze środka sprawiało,
 * że kolejne „Dodaj" trafiało w oznaczenie, które nadal było na liście.
 */
export function nextFreeDesignation(existing: (string | null | undefined)[], prefix = 'H'): string {
  const taken = new Set(existing.map(normKey));
  for (let n = 1; n <= 999; n++) {
    const candidate = `${prefix}-${String(n).padStart(2, '0')}`;
    if (!taken.has(normKey(candidate))) return candidate;
  }
  return `${prefix}-${Date.now()}`;
}
